
export const LOAD_REPORTS_REQUEST = "[REPORTS] LOAD REPORTS REQUEST";
export const LOAD_REPORTS_SUCCESS = "[REPORTS] LOAD_REPORTS_SUCCESS";
export const LOAD_REPORTS_ERROR = "[REPORTS] LOAD_REPORTS_ERROR";
export const SET_REPORT_URL = "[REPORTS] SET_REPORT_URL";


// WEBPACK FOOTER //
// ./src/modules/reports/reports-action-types.js